// extracted by mini-css-extract-plugin
export default {"speaker-select-wrapper":"SelectMediaDevices_speaker-select-wrapper__uaV5H","white-fill":"SelectMediaDevices_white-fill__KUEcJ"};